<template lang="html">
  <img class="mt-3 mb-3" src="@/assets/logo.svg" alt="logo" width="200" />
  <div class="container">
    <h1 class="title h-100">Vul je gegevens in</h1>
    <input
      v-model="firstName"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Voornaam"
      required
    />
    <input
      v-model="lastName"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Achternaam"
      required
    />
    <input
      v-model="email"
      class="form-control field no-focusborder border-dark"
      type="email"
      ref="inputfield"
      placeholder="E-mail"
      required
    />
    <span class="text-secondary">{{ validateEmail }}</span>
    <input
      v-model="phone"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Telefoonnummer"
      required
    />
    <!-- <input
      v-model="company"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Organisatie"
      required
    />
    <input
      v-model="jobposition"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Functie"
      required
    /> -->
    <input
      v-model="city"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Woonplaats"
      required
    />
    <input
      v-model="education"
      class="form-control field no-focusborder border-dark"
      type="text"
      ref="inputfield"
      placeholder="Huidige/afgeronde opleiding"
      required
    />
    <div class="d-grid gap-2">
      <button
        type="button"
        class="btn btn-secondary text-primary btn-lg"
        :disabled="isDisabled == true"
        @click="setPersonalData()"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    jobposition: null,
    company: null,
    city: null,
    education: null,
  }),
  computed: {
    isDisabled() {
      if (
        this.firstName &&
        this.lastName &&
        this.city &&
        this.education &&
        this.email
      ) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          return false;
        }
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setCompany", this.company);
      this.$store.commit("setJobposition", this.jobposition);
      this.$store.commit("setPhone", this.phone);
      this.$store.commit("setEmail", this.email);
      this.$store.commit("setQuestionOne", this.city);
      this.$store.commit("setQuestionTwo", this.education);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 30px;
  color: #4c52ad;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin-bottom: 5px !important;
  outline: none;
  padding: 10px;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 20px;
  color: #96fa6c;
  font-style: normal;
  font-weight: 300;
  background-color: #7b64bd;
}
.field::placeholder {
  color: #96fa6c;
}
</style>
